import * as React from 'react';
import { ConversationListContextValue } from './index.types';

export const ConversationListContext =
  React.createContext<ConversationListContextValue>({
    panelRef: null,
    isSecondaryMenuVisible: true,
  });

export const useConversationListContext = () => {
  const context = React.useContext(ConversationListContext);
  return context;
};
